import { createTheme, ThemeOptions } from "@mui/material";

const darkTheme: ThemeOptions = createTheme({
  palette: {

    primary: {
      main: "#859f64", //chnage this later
      light: '#a3c27bff',
      dark: '#688148ff',
      contrastText: '#fff',
      "50": "#f1f8e9",
      "100": "#dcedc8",
      "200": "#c5e1a5",
      "300": "#aed581",
      "400": "#9ccc65",
      "500": "#8bc34a",
      "600": "#7cb342",
      "700": "#689f38",
      "800": "#558b2f",
      "900": "#33691e"
    },
    info: {
      main: "#fff",
      light: '#ff7961',
      dark: '#859f64',
      contrastText: '#000',
    },
  },
});

export default darkTheme;
